import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../../../../utils/api";
import { LoginHelper } from "../../../../utils/LoginHelper";
import Button from "../../../common/button/Button";
import DetailAccentCard from "../../../common/detail/DetailAccentCard";

export default function AdminActionSection({ clip }) {
	const navigate = useNavigate();
	const [isOpen, setIsOpen] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");

	const handleRemove = () => {
		if (isLoading || !clip?.id) return;
		setIsLoading(true);
		api
			.videoClipRemove({
				token: LoginHelper.getToken(),
				clip_id: clip.id,
			})
			.then(() => {
				setIsLoading(false);
				navigate("/video_clips/");
			})
			.catch((err) => {
				setIsLoading(false);
				setErrorMessage(err?.data?.message || "حذف کلیپ ناموفق بود.");
			});
	};

	return (
		<DetailAccentCard bodyClassName="p-4" ariaLabel="مدیریت کلیپ">
			<p className="mb-3 font-Vazir-600 text-[13px] text-midGray">مدیریت</p>
			<div className="flex flex-col gap-2">
				<Link
					to="/dashboard/video-clips/"
					state={{ editClipId: clip.id }}
					className="rounded-[10px] bg-lightCta py-2.5 text-center font-Vazir-600 text-[14px] text-darkBlue no-underline transition hover:bg-[#E0EEF8]"
				>
					ویرایش
				</Link>
				<Link
					to="/dashboard/video-clips/"
					className="rounded-[10px] border border-darkBlue/15 bg-white py-2.5 text-center font-Vazir-600 text-[14px] text-darkBlue no-underline transition hover:border-darkBlue/30"
				>
					پنل مدیریت کلیپ
				</Link>
				<button
					type="button"
					className="rounded-[10px] bg-[#CC0000] py-2.5 font-Vazir-600 text-[14px] text-white transition hover:opacity-90"
					onClick={() => setIsOpen(!isOpen)}
				>
					حذف
				</button>
			</div>
			{isOpen && (
				<div className="mt-4 rounded-[10px] border border-darkBlue/10 bg-lightCta/50 p-3">
					<p className="font-Vazir-600 text-[14px] text-midGray">
						آیا از حذف این کلیپ مطمئن هستید؟
					</p>
					<div className="mt-3 flex flex-row items-center gap-2">
						<button
							type="button"
							className="rounded-[10px] bg-white px-3 py-1.5 font-Vazir-600 text-[13px] text-darkBlue"
							onClick={() => setIsOpen(false)}
						>
							خیر
						</button>
						<div className="min-h-[32px] min-w-[56px]">
							<Button
								onClick={handleRemove}
								label="بله"
								isLoading={isLoading}
								color="#CC0000"
								textColor="#ffffff"
							/>
						</div>
					</div>
				</div>
			)}
			{errorMessage && (
				<p className="mt-2 text-center font-Vazir-400 text-[13px] text-[#cc0000]">
					{errorMessage}
				</p>
			)}
		</DetailAccentCard>
	);
}
